@if (chapter.title && chapter.index > 0) {
    <div class="content-description">
        @if (realPageNumber > 0) {
            <span class="float-end">
        {{ chapter.index |realPageNumber }}
      </span>
        }
        @if (showChapterNames && hierachyContainsChapter) {
            <span class="chapter-label">{{ hierachy }}.</span>
        }
        @if (!showChapterNames) {
            <span class="chapter-label">{{ chapter.orderName }}</span>
        }
        <span class="chapter-title">{{ chapter.title }}</span>
    </div>
}